import { createReducer, on } from '@ngrx/store';
import * as fromState from '../states/static-data.state';

import * as staticDataActions from '../actions/static-data.action'
import { ConfigurationType } from 'src/app/settings/enums/configuration-type.enum';

export const staticDataFeatureKey = 'staticData';

export const reducer = createReducer(
  fromState.initialState,
  on(staticDataActions.loadStaticDataSuccess, (state, { reasons, presenceTypes, appointmentStates, userConfig, timeRangeConfigs }) => {
    return {
      ...state,
      reasons: reasons,
      presenceTypes: presenceTypes,
      appointmentStates: appointmentStates,
      userConfig,
      timeRangeConfigs
    };
  }),
  on(staticDataActions.loadMedicalHistoryDataSuccess, (state, { departments, inventoryList, firms, mhInitialization }) => {
    return {
      ...state,
      isloadedMedicalHistory: true,
      departments: departments,
      inventoryList: inventoryList,
      firms: firms,
      mhInitialization: mhInitialization
    };
  }),
  on(staticDataActions.loadHexDataSuccess, (state, { applicationTypes, servingModes }) => {
    return {
      ...state,
      isLoadedHexData: true,
      applicationTypes: applicationTypes,
      servingModes: servingModes,
    };
  }),
  on(staticDataActions.loadVersionSuccess, (state, { version }) => {
    return {
      ...state,
      version: version
    };
  }),
  on(staticDataActions.loadServiceArticleTreatmentDataSuccess, (state, { serviceArticleTreatments }) => {
    return {
      ...state,
      isLoadedServiceArticleTreatment: true,
      serviceArticleTreatments: serviceArticleTreatments,
    };
  }),

  on(staticDataActions.updateMhInitializationItems, (state, { newMhInitializationItems }) => {
    return {
      ...state,
      mhInitialization: newMhInitializationItems
    }
  }),
  on(staticDataActions.loadSpeciesDiagnosisDataSuccess, (state, { speciesDiagnoses }) => {
    return {
      ...state,
      isLoadedSpeciesDiagnosis: true,
      speciesDiagnoses: speciesDiagnoses,
    };
  }),
  on(staticDataActions.loadAnimalTypesSuccess, (state, { animalTypes }) => {
    return {
      ...state,
      isLoadedAnimalTypes: true,
      animalTypes: animalTypes
    };
  }),
  on(staticDataActions.loadFirmsSuccess, (state, { firms }) => {
    return {
      ...state,
      firms: firms
    };
  }),
  on(staticDataActions.loadLocationsSuccess, (state, { locations }) => {
    return {
      ...state,
      locations: locations
    };
  }),
  on(staticDataActions.loadCountryListSuccess, (state, { countryList }) => {
    return {
      ...state,
      isCountryListLoaded: true,
      countryList: countryList
    };
  }),
  on(staticDataActions.loadCountyListSuccess, (state, { countyList }) => {
    return {
      ...state,
      isCountyListLoaded: true,
      countyList: countyList
    };
  }),
  on(staticDataActions.updateLocation, (state, { location }) => {
    const locations = state.locations.map((loc) => {
      const locationAux = { ...loc }
      if (locationAux.isDefault && location.isDefault) {
        locationAux.isDefault = false;
      }
      if (locationAux.id === location.id) {
        return location;
      }
      return locationAux;
    });
    return {
      ...state,
      locations: locations
    };
  }),
  on(staticDataActions.removeLocation, (state, { location }) => {
    const locations = state.locations.filter((loc) => loc.id !== location.id);
    return {
      ...state,
      locations: locations
    };
  }),
  on(staticDataActions.updateBookSettings, (state, { bookSettings }) => {
    const bookSettingList = state.bookSettingList.map((book) => {
      if (book.bookId === bookSettings.bookId) {
        return bookSettings;
      }
      return book;
    });
    return {
      ...state,
      bookSettingList: bookSettingList
    };
  }),
  on(staticDataActions.updateAddress, (state, { entityId, addressId, typeEntity }) => {
    switch (typeEntity) {
      case ConfigurationType.DEPARTMENT: {
        const firms = state.firms.map((firm) => {
          if (firm.departments && firm.departments.length > 0) {
            const updatedDepartments = firm.departments.map(dep =>
              dep.departmentId === entityId ? { ...dep, addressId } : dep
            );
            return {
              ...firm,
              departments: updatedDepartments
            };
          }
          return firm;
        });

        return {
          ...state,
          firms
        };
      }
      case ConfigurationType.BOOK: {
        const bookSettingList = state.bookSettingList.map(book =>
          book.bookId === entityId ? { ...book, addressId } : book
        );

        return {
          ...state,
          bookSettingList
        };
      }
      case ConfigurationType.FIRM: {
        const firms = state.firms.map(firm =>
          firm.firmId === entityId ? { ...firm, addressId } : firm
        );

        return {
          ...state,
          firms
        };
      }
    }
    return {
      ...state,
    };
  }),

  on(staticDataActions.loadBookSettingListSuccess, (state, { bookSettingList }) => {
    const bookSettings = [...bookSettingList].sort((a, b) => {
      if (a.sortIndex !== undefined && b.sortIndex !== undefined) {
        if (a.sortIndex < b.sortIndex) {
          return -1;
        } else {
          return 1;
        }
      }
      return 0
    });
    return {
      ...state,
      isBookSettingListLoaded: true,
      bookSettingList: bookSettings
    };
  }),
  on(staticDataActions.updateDepartmentSettings, (state, { departmentSettings }) => {
    const firms = state.firms.map(firm => {
      if (firm.departments && firm.departments.length > 0) {
        const updatedDepartments = firm.departments.map(department => {
          if (department.departmentId === departmentSettings.departmentId) {
            return { ...department, ...departmentSettings };
          }
          return department;
        });

        return {
          ...firm,
          departments: updatedDepartments
        };
      }

      return firm;
    });

    return {
      ...state,
      firms
    };
  }),
  on(staticDataActions.clearSettingsData, (state) => ({
    ...state,
    locations: [],
    firms: [],
    departments: [],

    isloadedMedicalHistory: false,
    isLoadedHexData: false,
    isLoadedServiceArticleTreatment: false,
    isLoadedAnimalTypes: false,
    isLoadedSpeciesDiagnosis: false,
    isBookSettingListLoaded: false,
  })),
  on(staticDataActions.loadTranslationsSuccess, (state, { translations }) => {
    return {
      ...state,
      translations: state.translations.concat(translations),
    };
  }),
  on(staticDataActions.loadCustomerExternalNumbersDataSuccess, (state, { customerExternalNumbers }) => {
    return {
      ...state,
      isCustomerExternalNumbersLoaded: true,
      customerExternalNumbers: customerExternalNumbers,
    };
  }),
  on(staticDataActions.loadAnimalExternalNumbersDataSuccess, (state, { animalExternalNumbers }) => {
    return {
      ...state,
      isAnimalExternalNumbersLoaded: true,
      animalExternalNumbers: animalExternalNumbers,
    };
  }),
  on(staticDataActions.loadAnimalDateTypesDataSuccess, (state, { animalDateTypes }) => {
    return {
      ...state,
      isAnimalDateTypesLoaded: true,
      animalDateTypes: animalDateTypes,
    };
  }),
  on(staticDataActions.loadCustomerCategoryGroupDataSuccess, (state, { customerCategoryGroup }) => {
    return {
      ...state,
      isCustomerCategoryGroupLoaded: true,
      customerCategoryGroup: customerCategoryGroup,
    };
  }),
  on(staticDataActions.loadCustomerCategoryDataSuccess, (state, { customerCategory }) => {
    return {
      ...state,
      isCustomerCategoryLoaded: true,
      customerCategory: customerCategory,
    };
  }),

)
